import type { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';
import { getAssetUrl } from '@main/pdf/assets';

import type { IntegrationConnector } from './integration-connector';

export interface IntegrationService<
  TConnector extends IntegrationConnector = IntegrationConnector,
> {
  readonly ['_']: {
    ConnectorConfig: TConnector['_']['NamedConfig'];
  };

  name: Integration_Service_Names_Enum;
  logoPath?: string;
  connector: TConnector;
}

export function make<TConnector extends IntegrationConnector>(
  service: Omit<IntegrationService<TConnector>, '_'>,
) {
  return service as IntegrationService<TConnector>;
}

export function logoUrl(service: IntegrationService) {
  return getAssetUrl(service.logoPath ?? service.connector.logoPath);
}
